import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { IoIosCash } from "react-icons/io";

const BASE_URL = `${window.location.origin}`;
const storedUserDetails = localStorage.getItem("userdetails");
const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
const userRole = userDetails ? userDetails.role.toLowerCase() : null;
const companiesId = userDetails ? userDetails.companies_id : null; 

export const FinalSidebarData = [
  {
    title: 'Dashboard',
    path: '' + BASE_URL + '/dashboard',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text'
  },
  {
    title: 'Orders',
    path: '' + BASE_URL + '/orders',
    icon: <FaIcons.FaFileUpload />,
    cName: 'nav-text'
  },
  {
    title: 'Devices',
    path: '' + BASE_URL + '/devices',
    icon: <GpsFixedIcon />,
    cName: 'nav-text'
  },
  {
    title: 'Billing',
    path: '' + BASE_URL + '/billing',
    icon: <IoIosCash />,
    cName: 'nav-text'
  },
  {
    title: 'Vehicles',
    path: '' + BASE_URL + '/vehicles',
    icon: <FaIcons.FaCarAlt />,
    cName: 'nav-text'
  },
  {
    title: 'Drivers',
    path: '' + BASE_URL + '/drivers',
    icon: <FaIcons.FaUser />,
    cName: 'nav-text'
  },
  {
    title: 'Earnings',
    path: '' + BASE_URL + '/earnings',
    icon: <IoIosCash />,
    cName: 'nav-text'
  },
  {
    title: 'Routes',
    path: '',
    icon: <FaIcons.FaMapMarkerAlt />,
    cName: 'nav-text'
  },
  {
    title: 'Offers',
    path: '/offers',
    icon: <FaIcons.FaGift />,
    cName: 'nav-text',
    target: userRole === 'platform_user' ? '_blank' : '_self',
    rel: userRole === 'platform_user' ? 'noopener noreferrer' : undefined
  },
  {
    title: 'Reports',
    path: '/reports',
    icon: <IoIcons.IoIosPaper />,
    cName: 'nav-text'
  },
  {
    title: 'Whatsapp',
    path: '',
    icon: <FaIcons.FaWhatsapp />,
    cName: 'nav-text'
  },
  {
    title: 'Companies',
    path: '' + BASE_URL + '/company',
    icon: <CorporateFareIcon/>,
    cName: 'nav-text'
  },
  {
    title: 'Clients',
    path: '' + BASE_URL + '/clients',
    icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />,
    cName: 'nav-text'
  },
  {
    title: 'Vendors',
    path: '' + BASE_URL + '/vendors',
    icon:  <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />,
    cName: 'nav-text'
  },
  {
    title: 'Warehouses',
    path: '' + BASE_URL + '/warehouses',
    icon: <FaIcons.FaWarehouse style={{ color: 'white' }} />,
    cName: 'nav-text'
  },
  {
    title: 'Users',
    path: '' + BASE_URL + '/users',
    icon: <FaIcons.FaUserShield style={{ color: 'white' }} />,
    cName: 'nav-text'
  }
];

const getVendorCompanyAdminSidebar = () => {
  const adminFeatures = {
    title: 'Admin Features',
    icon: <FaIcons.FaUserTie />,
    cName: 'nav-text',
    subNav: [
      {
        title: 'Clients',
        path: '' + BASE_URL + '/clients',
        icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />,
        cName: 'nav-text'
      },
      {
        title: 'Warehouses',
        path: '' + BASE_URL + '/warehouses',
        icon: <FaIcons.FaWarehouse style={{ color: 'white' }} />,
        cName: 'nav-text'
      },
      {
        title: 'Users',
        path: '' + BASE_URL + '/users',
        icon: <FaIcons.FaUserShield style={{ color: 'white' }} />,
        cName: 'nav-text'
      }
    ]
  };

  return FinalSidebarData.filter(item =>
    item.title !== 'Companies' &&
    item.title !== 'Clients' &&
    item.title !== 'Warehouses' &&
    item.title !== 'Users' &&
    item.title !== 'Vendors' &&
    item.title !== 'Devices' &&
    item.title !== 'Billing'
  ).concat([adminFeatures]);
};

const getClientCompanyAdminSidebar = () => {
  const adminFeatures = {
    title: 'Admin Features',
    icon: <FaIcons.FaUserTie />,
    cName: 'nav-text',
    subNav: [
      {
        title: 'Vendors',
        path: '' + BASE_URL + '/vendors',
        icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />,
        cName: 'nav-text'
      },
      {
        title: 'Warehouses',
        path: '' + BASE_URL + '/warehouses',
        icon: <FaIcons.FaWarehouse style={{ color: 'white' }} />,
        cName: 'nav-text'
      },
      {
        title: 'Users',
        path: '' + BASE_URL + '/users',
        icon: <FaIcons.FaUserShield style={{ color: 'white' }} />,
        cName: 'nav-text'
      }
    ]
  };

  return FinalSidebarData.filter(item =>
    item.title !== 'Routes' &&
    item.title !== 'Clients' &&
    item.title !== 'Vendors' &&
    item.title !== 'Warehouses' &&
    item.title !== 'Users' &&
    item.title !== 'Companies' &&
    item.title !== 'Devices' &&
    item.title !== 'Billing'
  ).concat([adminFeatures]);
};

const filteredSidebarData = (() => {
  
  if (userRole === 'platform_user') {
    if (companiesId != 1) {
      return FinalSidebarData.filter(item => 
        ['Companies', 'Offers', 'Vehicles', 'Devices', 'Billing'].includes(item.title)
      );
    } 
    else {
      return FinalSidebarData.filter(item => 
        ['Companies', 'Offers', 'Devices', 'Billing'].includes(item.title)
      );
    }
  }
  let data = [];
  
  switch(userRole) {
    case 'vendor_supervisor':
      data = FinalSidebarData.filter(item =>
        item.title !== 'Companies' &&
        item.title !== 'Vendors' &&
        item.title !== 'Clients' &&
        item.title !== 'Warehouses' &&
        item.title !== 'Users' &&
        item.title !== 'Devices' &&
        item.title !== 'Billing' 
      );
      break;
    
    case 'vendor_company_admin':
      data = getVendorCompanyAdminSidebar();
      break;

    case 'client_company_admin':
      data = getClientCompanyAdminSidebar();
      break;

    default:
      data = FinalSidebarData.filter(item => 
        item.title !== 'Offers' && 
        item.title !== 'Devices' &&
        item.title !== 'Billing'
      );
      break;
  }
  
  if (companiesId != 1) {
    const restrictedItems = ['Offers', 'Whatsapp', 'Routes', 'Earnings'];
    data = data.filter(item => !restrictedItems.includes(item.title));
  }
  return data;
})();

export default filteredSidebarData;